import { SvgIcon, createSvgIcon } from "@mui/material";

const NoteHalfIcon = createSvgIcon(
  <SvgIcon viewBox="0 0 8 25.74">
    <path d="M7,0V19.15a2.55,2.55,0,0,0-1.32-.41H5.39A6,6,0,0,0,.88,21.1a3.29,3.29,0,0,0-.62,3.42,2.5,2.5,0,0,0,2.44,1.21,6,6,0,0,0,4.21-2.12A4,4,0,0,0,8,21H8V0ZM6.13,22.35A9.13,9.13,0,0,1,2,24.71c-.46.08-1.2.16-1.34-.45s.35-1.2.71-1.67A9.84,9.84,0,0,1,4.85,20.1,2.93,2.93,0,0,1,7,19.84a.6.6,0,0,1,.31.55A3.64,3.64,0,0,1,6.13,22.35Z"/>
  </SvgIcon>
);

export default NoteHalfIcon;